module.exports = __webpack_public_path__ + "static/loading-d576934d47c4fdcbf32fb0d012bcc7a8.gif";